import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initScrollReveal() {
    requestAnimationFrame(() => {
        const items = document.querySelectorAll('.js-inview-section:not(.inview)');
        
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const item = entry.target;
                        const inner = item.querySelector('.js-inview-section__inner');
                        const children = item.querySelectorAll('.js-inview-section__child');

                        item.classList.add('inview');

                        const tl = gsap.timeline();

                        if (inner) {
                            tl.fromTo(inner, {
                                translate: `0px 20px`,
                                opacity: 0,
                            }, {
                                ease: "power3.out",
                                translate: `0px 0px`,
                                opacity: 1,
                                duration: 0.6
                            });
                        }

                        if (children.length > 0) {
                            tl.fromTo(children, {
                                translate: `10px 0px`,
                                opacity: 0,
                            }, {
                                ease: "power3.out",
                                translate: `0px 0px`,
                                opacity: 1,
                                stagger: 0.1,
                                duration: 0.6
                            }, "-=0.3");
                        }

                        observer.unobserve(item);
                    }
                });
            },
            {
                rootMargin: `0px 0px -${window.innerHeight * 15 / 100}px 0px`,
                threshold: 0.01
            }
        );

        items.forEach(item => {
            const inner = item.querySelector('.js-inview-section__inner');
            const children = item.querySelectorAll('.js-inview-section__child');

            gsap.set([inner, ...children], {
                translate: `0 20px`,
                opacity: 0,
            });

            observer.observe(item);
        });
    });
}